<template>
  <v-main :class="{ 'auth-background': !$vuetify.breakpoint.xs }">
    <v-container class="pa-0" style="max-width: 1000px">
      <v-row>
        <v-col cols="12" md="5" class="logo pa-0">
          <div v-if="$vuetify.breakpoint.mdAndUp" class="logo-md-only"></div>

          <div v-else class="logo-xs-container">
            <v-img src="../../assets/tqb_logo_horizontal.svg" contain class="logo-xs"></v-img>
          </div>
        </v-col>

        <v-col style="background: #fff" cols="12" md="7">
          <div class="mx-sm-4 px-sm-4 mx-md-10 px-md-10 py-md-4 xs-screen">
            <div class="d-flex justify-center">
              <div class="text-h4 py-5 font-weight-bold" style="color: #4C5183">Đăng nhập</div>
            </div>
            <v-form ref="form">
              <v-text-field
                placeholder="Tài Khoản"
                name="login"
                prepend-inner-icon="person"
                v-model="credentials.identifier"
                :rules="[$rules.required, $rules.minLength(4)]"
                validate-on-blur
                @keyup.enter="submit"
                type="text"
                color="#4C5183"
              />

              <v-text-field
                placeholder="Mật khẩu"
                v-model="credentials.password"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                @click:append="showPassword = !showPassword"
                :type="showPassword ? 'text' : 'password'"
                :rules="[$rules.required, $rules.minLength(4)]"
                validate-on-blur
                @keyup.enter="submit"
                prepend-inner-icon="lock"
                color="#4C5183"
              />
            </v-form>
            <v-card-actions class="d-flex flex-column justify-content-center py-6">
              <v-btn color="#4C5183" class="px-12 white--text" x-large @click="submit">Đăng Nhập</v-btn>
            </v-card-actions>
            <v-divider style="width: 100%;" class="my-6"></v-divider>

            <div class="d-flex justify-center align-center">
              <v-btn
                color="#ffffff"
                class="px-12"
                x-large
                outlined
                @click="redirectToMicrosoft"
                style="border: 1px solid #ccc; color: #4C5183"
              >
                <v-img
                  src="../../assets/icons/Microsoft_logo.svg"
                  alt="Microsoft Logo"
                  contain
                  class="mr-3 microsoft-logo"
                />
                Sử dụng tài khoản Microsoft
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
import { mapActions, mapState } from 'vuex'
import router from '@/router'
import { get } from 'lodash'

export default {
  data() {
    return {
      credentials: {
        identifier: '',
        password: ''
      },
      showPassword: false,
      rules: {
        min: v => v.length >= 6 || 'Min 6 characters',
        emailMatch: () => "The email and password you entered don't match"
      }
    }
  },
  computed: {
    ...mapState('auth', ['user', 'isAuthenticated'])
  },
  async created() {
    if (this.$route.query['access_token']) {
      await this.authentication()
    }
  },
  methods: {
    ...mapActions('auth', ['signIn', 'microSignIn']),
    async submit() {
      if (this.$refs.form.validate()) {
        this.$loading.active = true
        await this.signIn(this.credentials)
        this.$loading.active = false

        if (this.user && this.isAuthenticated) {
          const userRole = get(this.user, 'role.type')
          if (userRole) {
            switch (userRole) {
              case 'teacher':
                router.push('/teacher-dashboard')
                break
              default:
                router.push('/dashboard')
            }
          }
        }
      }
    },
    async authentication() {
      if (this.$route.query['access_token']) {
        console.log(this.$route.query['access_token'])
        this.$loading.active = true
        await this.microSignIn({ access_token: this.$route.query['access_token'] })
        this.$loading.active = false

        if (this.user && this.isAuthenticated) {
          const userRole = get(this.user, 'role.type')
          if (userRole) {
            switch (userRole) {
              case 'teacher':
                router.push('/teacher-dashboard')
                break
              default:
                router.push('/dashboard')
            }
          }
        }
      }
    },
    redirectToMicrosoft() {
      window.location.href = `${this.$baseUrl}connect/microsoft`
    }
  }
}
</script>
<style scoped>
.auth-background {
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  z-index: 1;
}

.auth-background::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('../../assets/tqb_school_bg.png') no-repeat center center;
  background-size: cover;
  filter: blur(4px);
  transform: scale(1.05);
  z-index: -1;
}

.v-main {
  position: relative;
  z-index: 1;
}

.v-container,
.v-col {
  position: relative;
  z-index: 2;
}

.logo {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;
  width: 100%;
  z-index: 2;
}

.logo-md-only {
  background: url('../../assets/tqb_login_side.jpg') no-repeat center center;
  background-size: cover;
  width: 100%;
  height: 504px;
}

.logo-xs-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-height: 130px;

  background-color: #eeeeee;
  position: relative;
  padding: 24px;
}

.logo-xs {
  max-height: 100px;
  width: 100%;
  object-fit: contain;
}
.microsoft-logo {
  width: 32px;
  height: 32px;
  object-fit: contain;
}
</style>
